import { VehicleService } from "../../../service/vehicle-service";
import types from "./types";

const fetchCustomerReviewsSuccess = (data) => ({
    type: types.FETCH_REVIEWS_SUCCESS,
    list: data
});

const fetchCustomerReviewsFailure = () => ({ type: types.FETCH_REVIEWS_FAILURE });

const getCustomerReviews = (payload) => (dispatch) => {
    return new Promise((resolve, reject) => {
        VehicleService.getCustomerReviews(payload)
            .then(response => {
                resolve(response.data.detail.reviews.reviewData);
                if (!payload.isLocal) {
                    dispatch(fetchCustomerReviewsSuccess(response.data.detail.reviews.reviewData));
                }
            }).catch(error => {
                dispatch(fetchCustomerReviewsFailure());
                reject(error);
            });
    });
};

export {
    getCustomerReviews
};
